import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../app/routes";

export default function TableItemActions({ row, editData }) {
  const viewDetails = () => {
    document.location.href = routes.api.file_imports.show(row.id);
  };

  const runProcess = () => {
    alert("run");
  };

  const edit = (row) => {
    editData(row);
  };

  return (
    <>
      {row.attributes.type_import == "member_import" && (
        <a
          onClick={() => runProcess(row.id)}
          className="btn btn-primary mr5"
          title="Start Process"
          data-toggle="tooltip"
        >
          <i className="fa fa-fw fa-play"></i>
        </a>
      )}

      {row.attributes.type_import == "enterprise_students" && (
        <a
          onClick={() => viewDetails(row.id)}
          className="btn btn-primary  mr5"
          title="View Details"
          data-toggle="tooltip"
        >
          <i className="fa fa-fw fa-eye"></i>
        </a>
      )}

      {['member_import', 'manual', 'file', 'finch_manual', 'finch_automatic'].includes(row.attributes.type_import) && (
        <a
          href={routes.api.file_import_items.index(row.id)}
          className="btn btn-primary mr5"
          title="Records"
          data-toggle="tooltip"
        >
          <i className="fa fa-fw fa-list"></i>
        </a>
      )}

      {row.attributes.type_import == "member_import" && (
        <a
          onClick={() => edit(row)}
          className="btn btn-primary mr5"
          title="Edit"
          data-toggle="tooltip"
        >
          <i className="fa fa-fw fa-edit"></i>
        </a>
      )}
    </>
  );
}
